import TokenStore from "./TokenStore";
import { post, get } from "./fetch";

const HOST = process.env.REACT_APP_ENDPOINT;
const AGENCIES_HOST = process.env.REACT_APP_AGENCIES_ENDPOINT;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

let tokenStore = new TokenStore({
  onError: () => {
    window.location = "/"; // TODO: Find a better form of managing this error.
  },
  onRefreshToken: refreshToken,
});

export async function login({ username, password }, remember) {
  try {
    const auth = await post(`${HOST}/api/token/`, { username, password });
    const { access, refresh } = auth;
    if (remember) {
      tokenStore.enablePersistence();
    }

    tokenStore.setToken(access);
    tokenStore.setRefreshToken(refresh);

    sessionStorage.setItem('username', username)
  
    return auth;
  } catch (error) {
    throw error.message ?? error;
  }
}

async function refreshToken(refresh) {
  try {
    const { access } = await post(`${HOST}/api/token/refresh/`, { refresh });
    return access;
  } catch (error) {
    throw error.message ?? error;
  }
}

export function isLoggedIn() {
  return !!tokenStore.getToken();
}

export async function fetchQuery(
  operation,
  variables,
  cacheConfig,
  uploadables
) {
  return await post(
    `${HOST}/graphql/`,
    { query: operation.text, variables },
    tokenStore.getToken(),
    uploadables
  );
}

export async function getAgencies() {
  return await get(`${AGENCIES_HOST}`, {
    "x-api-key": X_API_KEY,
  });

  // return [
  //   { agency_code: "CH", name: "Media markt", type: "0" }
  //   // { name: "El corte Ingles", value: "ci" }
  // ];
}

export async function logout() {
  tokenStore.clearTokens();
}
